import { Pipe, PipeTransform } from '@angular/core';
import { Many, orderBy } from 'lodash';
import { ReportLabelEnum } from '../../enums/report-label-enum';
import { MOptimReport } from '../../models/m-optim-report';
import { DateUtils } from '../../utils/date-utils';

export type SortOrder = 'asc' | 'desc';

@Pipe({
	name: 'orderByReport'
})
export class OrderByReportPipe implements PipeTransform {
	transform(
		value: MOptimReport[],
		sortKey: string | string = 'id',
		sortOrder: SortOrder | string = 'asc'
	): any {
		if (!value || value.length < 1 || !sortKey || sortKey === '') {
			return value;
		}
		return value.sort((a, b) => {
			const firstValueStr = a.report.criteriaReports.find(
				(crit) => crit.label === sortKey
			)?.finalValue;

			const secondValueStr = b.report.criteriaReports.find(
				(crit) => crit.label === sortKey
			)?.finalValue;

			let firstValue = 0;
			let secondValue = 0;
			if (firstValueStr?.includes('h') || firstValueStr?.includes('m')) {
				let dateUtils = new DateUtils();
				firstValue = dateUtils.convertStringHoursMinToNumber(firstValueStr);
				secondValue = dateUtils.convertStringHoursMinToNumber(secondValueStr);
			} else {
				firstValue = parseFloat(firstValueStr);
				secondValue = parseFloat(secondValueStr);
			}

			if (sortOrder === 'asc') {
				return firstValue - secondValue;
			} else if (sortOrder === 'desc') {
				return secondValue - firstValue;
			}
		});
	}
}
